<script>
	import { slugify } from "cando-util";
	import Form from "./FormSubmission/Form.svelte";

	export let lang;
	export let data;
	export let col;
	export let settingId;
	export let preview = false;
	export let allowReset = true;
	export let allowHideTags = true;

	$: formId =
		data.content?.[col]?.[settingId]?.general?.value?.id?.value ||
		`${slugify(col)}-${slugify(settingId)}-form`;
</script>

<section id={formId}>
	<div class={`max-w-[1440px] mx-auto px-2 sm:px-4`}>
		<Form
			{lang}
			{preview}
			{settingId}
			{data}
			{col}
			{allowReset}
			{allowHideTags}
		/>
	</div>
</section>
